import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { useNavigate } from 'react-router-dom';
import ProductCategory1 from '../wrappers/Product-category-section/product-category1';
import ProductCategory2 from '../wrappers/Product-category-section/product-category2';
// import ProductCategory3 from '../wrappers/Product-category-section/product-category3';
// import ProductCategory4 from '../wrappers/Product-category-section/product-category4';
// import ProductCategory5 from '../wrappers/Product-category-section/product-category5';
const Wrappers = () => {
  const navigate=useNavigate()
  return (
    <>
    <div className="container-fluid  bags-container d-flex align-items-center" >
      <div className="row justify-content-center w-100">
        <div className="col-12 col-lg-10">
          <div className="card-banner">
            <div className="row g-0">
              {/* Left side with single product image */}
              <div className="col-md-6  d-flex align-items-center justify-content-center p-5" >
                <img
                  src="/assets/products-with-logo/paper-bags/wrappers.jpg"
                  className="img-fluid"
                  alt="wrapper"
                  style={{
                    maxWidth: '100%',
                    height: 'auto',
                    objectFit: 'contain'
                  }}
                />
              </div>
              
              {/* Right side content */}
              <div className="col-md-6 d-flex align-items-center" >
                <div className="p-4 p-lg-5 w-100">
                  <small className="text-black text-uppercase letter-spacing-1 mb-2 d-block">
                  Versatile, protective, efficient
                  </small>
                  
                  <h2 className="main-heading display-5 fw-bold text-dark mb-4">
        Packaging Wrappers                  
    </h2>
    
    <p className="product-each-desc text-black mb-4 lead">
        {/* Premium quality wrappers offering superior protection and versatility, suitable for various packaging needs from food service to industrial applications, retail merchandise to gift wrapping solutions. */}

        KLM Wrappers have been designed to provide excellent grease resistance and heat retention for all your food packaging needs. Explore our range of home compostable Renewable Waxed Wraps for eco-friendly options, alongside our Deli-Wraps that are perfect for sandwiches, baguettes, and bakery items. For your burger menu, consider our specialized Burger & Fresh Wraps that offer the ideal combination of functionality and presentation.
    </p>
                  
                  <div className="text-center mb-4">
                    <button 
                      className="btn btn-dark btn-sm rounded-pill text-uppercase mx-auto" 
                      style={{ 
                        width: '100px',
                        fontSize: '0.6rem',
                        padding: '10px 2px',
                        lineHeight: '1.2',
                        display: 'block'
                      }} onClick={()=>{navigate('/contact')}}>
                      Contact Us
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <ProductCategory1/>
    <ProductCategory2/>
 
    {/* <ProductCategory3/>
     <ProductCategory4/>
    <ProductCategory5/> */}
</>
  );
};

export default Wrappers;